import { render, staticRenderFns } from "./refer-friends.vue?vue&type=template&id=695553c0&scoped=true"
import script from "./refer-friends.vue?vue&type=script&lang=js"
export * from "./refer-friends.vue?vue&type=script&lang=js"
import style0 from "./refer-friends.vue?vue&type=style&index=0&id=695553c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695553c0",
  null
  
)

export default component.exports